import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { apiUrl } from '../../config/Config';
import { useSelector } from 'react-redux';
const PerformanceTrendsChart = ({selectedaccount}) => {
  console.log('PerformanceTrendsChart selectedaccount >>', selectedaccount);
      const userdata = useSelector(store => store.userReducer.userdata);
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "line",
        toolbar: { show: false },
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      markers: {
        size: 5,
        strokeWidth: 2,
      },
      xaxis: {
        categories: [],
        labels: { style: { fontSize: "13px" } },
      },
      yaxis: {
        title: { text: "Count" },
        labels: { style: { fontSize: "13px" } },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        markers: { radius: 12 },
      },
      grid: {
        strokeDashArray: 4,
      },
      colors: ["#2d7ff9", "#1db954"], // blue, green
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(apiUrl + 'facebook_datewise_combined_insights', {
                params: { ad_account_id: selectedaccount, range_type: 'last_7_days' },
                headers: { Authorization: 'Bearer ' + userdata?.token }
            }); // replace with your API
        const data = res?.data?.data?.data?.data; // array of daily stats
        console.log('testing data >>', data);

        // Extract categories (dates)
        const categories = data.map((item) => item.date);
        console.log('clicks >>', categories)

        // Extract series data
        const clicksData = data.map((item) => item.clicks);
        const impressionsData = data.map((item) => item.impressions);

        setChartData((prev) => ({
          ...prev,
          series: [
            { name: "Clicks", data: clicksData },
            { name: "Impressions", data: impressionsData },
          ],
          options: {
            ...prev.options,
            xaxis: {
              ...prev.options.xaxis,
              categories: categories,
            },
          },
        }));
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    };

    fetchData();
  }, []);

  return <Chart options={chartData.options} series={chartData.series} height={300} />;
};

export default PerformanceTrendsChart;
